export enum AddOnSlug {
  AI = 'ai',
}
